import { getAllUsers } from '../services/userService';

/**
 * Fetches all users and filters usernames by sub_county_id.
 */
export const fetchUsernamesBySubCounty = async (input_sub_county_id) => {
    try {
        const data = await getAllUsers();
        if (!Array.isArray(data)) return [];

        return data
            .filter(user => Number(user.sub_county_id) === Number(input_sub_county_id))
            .map(user => user.username);
    } catch (err) {
        console.error("Utility Error:", err);
        return [];
    }
};
export const fetchRoNamesBySubCounty = async (input_sub_county_id) => {
    try {
        const data = await getAllUsers();
        if (!Array.isArray(data)) return [];

        return data
            .filter(user => (Number(user.sub_county_id) === Number(input_sub_county_id)) && (user.role === 'Sub County Revenue Officer'))
            .map(user => user.username);
    } catch (err) {
        console.error("Utility Error:", err);
        return [];
    }
};